import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const baseStyle = defineStyle({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 500,
  borderRadius: '4px',
  textTransform: 'none',
  letterSpacing: '0.2px',
})

const sizes = {
  sm: defineStyle({
    fontSize: '12px',
    lineHeight: 'normal',
    padding: '4px 8px',
  }),
  md: defineStyle({
    fontSize: '14px',
    lineHeight: 'normal',
    padding: '6px 12px',
  }),
  lg: defineStyle({
    fontSize: '16px',
    lineHeight: 'normal',
    padding: '8px 16px',
  }),
}

const primary = defineStyle({
  bg: 'presets.turquoise.60',
  color: 'presets.neutral.0',
  _dark: {
    bg: 'presets.turquoise.40',
    color: 'presets.neutral.0',
  },
})

const secondary = defineStyle({
  bg: 'transparent',
  color: 'presets.turquoise.100',
  border: '1px solid',
  borderColor: 'presets.neutral.30',
  _dark: {
    color: 'presets.turquoise.30',
    borderColor: 'presets.neutral.60',
  },
})

const tertiary = defineStyle({
  bg: 'transparent',
  color: 'presets.turquoise.70',
  _dark: {
    color: 'presets.turquoise.40',
  },
})

const danger = defineStyle({
  bg: 'presets.pink.70',
  color: 'presets.neutral.0',
  _dark: {
    bg: 'presets.pink.60',
    color: 'presets.neutral.0',
  },
})

const simple = defineStyle({
  bg: 'transparent',
  color: 'presets.turquoise.100',
  _dark: {
    color: 'presets.turquoise.30',
  },
})

const solid = defineStyle(props => {
  const { colorScheme: c = 'gray' } = props
  return {
    bg: `${c}.500`,
    color: 'white',
  }
})

const subtle = defineStyle(props => {
  const { colorScheme: c = 'gray' } = props
  return {
    bg: `${c}.100`,
    color: `${c}.800`,
  }
})

export const badgeTheme = defineStyleConfig({
  baseStyle,
  variants: {
    primary,
    secondary,
    tertiary,
    danger,
    simple,
    solid,
    subtle,
  },
  sizes,
  defaultProps: {
    variant: 'primary',
    size: 'md',
  },
})
